import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'antd';
import ButtonComponent from 'components/Button';
import { getArrayStatusFormatted, getLabelCargoFas } from 'utils/funcaoPadrao';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { fetchStatusModal, fetchStatusModalJustificativa } from 'store/fetchActions/fetchApp';
import {
  FileFilled,
  SmileFilled,
  FileImageFilled,
  CheckCircleFilled,
  EditFilled,
  FolderOpenFilled,
} from '@ant-design/icons';
import * as S from './styles';

export const ResponderJustificativa = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(state => state.app.modal);
  const dadosMinimizados = useSelector(state => state.app.dadosMinimizados);
  const dadosDetalhar = useSelector(state => state.formulario.dadosExibirDetalhar);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);

  const getPrimeiraJustificativaContribuinte = () => {
    return dadosDetalhar?.formularioJustificativas?.find(x => x.isAtendente === false)?.justificativa;
  };

  return (
    <>
      <S.TitleResumo>
        Finalizando o requerimento <b>{dadosDetalhar?.localizador}</b>
      </S.TitleResumo>
      <S.ResumoStepsContainerRow>
        <S.ResumoStepsCirculo>
          <FileFilled />
        </S.ResumoStepsCirculo>
        <S.ResumoStepsContainerText>
          <S.ResumoStepsTitle>Requerimento</S.ResumoStepsTitle>
          <S.ResumoStepsSubtitle>
            Requerimento Solicitado por {dadosDetalhar?.formularioPessoa?.pessoa?.nome} em{' '}
            {convertDatePtBrHs(dadosDetalhar?.dataAbertura)}
          </S.ResumoStepsSubtitle>
        </S.ResumoStepsContainerText>
      </S.ResumoStepsContainerRow>
      <S.ResumoStepsLinha />

      <S.ResumoStepsContainerRow>
        <S.ResumoStepsCirculo>
          <FolderOpenFilled />
        </S.ResumoStepsCirculo>
        <S.ResumoStepsContainerText>
          <S.ResumoStepsTitle>Finalidade {dadosDetalhar?.solicitacao?.descricao}</S.ResumoStepsTitle>
          <S.ResumoStepsSubtitle>Solicitou o requerimento de {dadosDetalhar?.assunto?.descricao}</S.ResumoStepsSubtitle>
        </S.ResumoStepsContainerText>
      </S.ResumoStepsContainerRow>
      <S.ResumoStepsLinha />

      <S.ResumoStepsContainerRow>
        <S.ResumoStepsCirculo>
          <SmileFilled />
        </S.ResumoStepsCirculo>
        <S.ResumoStepsContainerText>
          <S.ResumoStepsTitle>Atendente</S.ResumoStepsTitle>
          <S.ResumoStepsSubtitle>
            O Atendente atual do requerimento é {atendenteLogado.nome} com cargo de{' '}
            {getLabelCargoFas(atendenteLogado?.cargoId, atendenteLogado?.isSetorial)}
          </S.ResumoStepsSubtitle>
        </S.ResumoStepsContainerText>
      </S.ResumoStepsContainerRow>
      <S.ResumoStepsLinha />

      <S.ResumoStepsContainerRow>
        <S.ResumoStepsCirculo>
          <EditFilled />
        </S.ResumoStepsCirculo>
        <S.ResumoStepsContainerText>
          <S.ResumoStepsTitle>Solicitação</S.ResumoStepsTitle>
          <S.ResumoStepsSubtitle>
            <td
              dangerouslySetInnerHTML={{
                __html: getPrimeiraJustificativaContribuinte(),
              }}
            />
          </S.ResumoStepsSubtitle>
        </S.ResumoStepsContainerText>
      </S.ResumoStepsContainerRow>
      <S.ResumoStepsLinha />
      <S.ResumoStepsContainerRow>
        <S.ResumoStepsCirculo>
          <FileImageFilled />
        </S.ResumoStepsCirculo>
        <S.ResumoStepsContainerText>
          <S.ResumoStepsTitle>Arquivos</S.ResumoStepsTitle>
          <S.ResumoStepsSubtitle>
            O contribuinte anexou um total de{' '}
            {dadosDetalhar?.arquivos?.filter(x => x?.atribuicao === 'CONTRIBUINTE')?.length} arquivo(s). Troca total de{' '}
            {dadosDetalhar?.arquivos?.length} arquivo(s)
          </S.ResumoStepsSubtitle>
        </S.ResumoStepsContainerText>
      </S.ResumoStepsContainerRow>
      <S.ResumoStepsLinha />

      <S.ResumoStepsContainerRow>
        <S.ResumoStepsCirculo>
          <CheckCircleFilled />
        </S.ResumoStepsCirculo>
        <S.ResumoStepsContainerText>
          <S.ResumoStepsTitle>
            {getArrayStatusFormatted().find(x => x.identificador === modalState.props.status)?.descricao} com{' '}
            {modalState?.props?.arquivos?.filter(x => !x?.formularioId)?.length} Novo(s) arquivo(s).
          </S.ResumoStepsTitle>
          <S.ResumoStepsSubtitle>
            <td
              dangerouslySetInnerHTML={{
                __html: modalState?.props?.justificativa,
              }}
            />
          </S.ResumoStepsSubtitle>
        </S.ResumoStepsContainerText>
      </S.ResumoStepsContainerRow>

      <S.ResumoFinalizar>Gostaria de finalizar esse requerimento?</S.ResumoFinalizar>
      <Row>
        <ButtonComponent
          text={'Finalizar'}
          clickAction={() => modalState.props.funcFinalizar(modalState.props.status)}
        />
        <ButtonComponent
          style={{ marginLeft: '10px' }}
          text={'Voltar'}
          clickAction={() => {
            dispatch(fetchStatusModal(false, ''));
            dispatch(fetchStatusModalJustificativa(true, atendenteLogado?.isSetorial, dadosMinimizados.nameModal));
          }}
        />
      </Row>
    </>
  );
};

export default ResponderJustificativa;
